import { useEffect, useState } from 'react';
import { ReactComponent as CloseSvg } from '../../../../assets/svg/closeCircle.svg';
import request from '../../../../lib/request';
import TextInput from '../../../../components/textInput';

const ChangePasswordDialog = ({ dialogRef, closeDialog, isDialogOpen }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [reuseOldPasswordError, setReuseOldPasswordError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);

  const reset = () => {
    setOldPassword('');
    setPassword('');
    setConfirmPassword('');
    setReuseOldPasswordError(false);
    setPasswordError(false);
    setConfirmPasswordError(false);
  };

  const handleInputChange = (key) => (e) => {
    const value = e.target.value;
    if (key === 'oldPassword') {
      setOldPassword(value);
    }
    if (key === 'password') {
      const passwordRegex = /^(?=.*[a-z])(?=.*\d)[\w\W]{8,}$/;
      if (passwordRegex.test(value)) {
        setPasswordError(false);
      }
      if (!passwordRegex.test(value) || value.length < 8 || value.length > 16) {
        setPasswordError(true);
      }
      if (oldPassword === value) {
        setReuseOldPasswordError(true);
      }
      if (oldPassword !== value) {
        setReuseOldPasswordError(false);
      }
      setPassword(value);
    }
    if (key === 'confirmPassword') {
      if (password === value) {
        setConfirmPasswordError(false);
      }
      if (password !== value) {
        setConfirmPasswordError(true);
      }
      setConfirmPassword(value);
    }
  };

  const handleSubmit = async () => {
    try {
      const isValid =
        oldPassword &&
        password &&
        confirmPassword &&
        !reuseOldPasswordError &&
        !passwordError &&
        !confirmPasswordError;

      if (isValid) {
        const data = { oldPassword, password };
        const { result } = await request.put('/user/change-password', data);
        closeDialog();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCancel = () => {
    reset();
    closeDialog();
  };

  return (
    <dialog
      ref={dialogRef}
      className='p-4 rounded-xl space-y-2 w-full text-sm'
    >
      <div className='flex justify-end'>
        <button onClick={handleCancel}>
          <CloseSvg />
        </button>
      </div>
      <div>
        <TextInput
          label='Old Password'
          onChange={handleInputChange('oldPassword')}
          value={oldPassword}
          placeholder='Enter your old password'
          type='password'
        />
      </div>
      <div>
        <TextInput
          label='New Password'
          onChange={handleInputChange('password')}
          value={password}
          placeholder='Enter your password'
          type='password'
        />
        {reuseOldPasswordError ? (
          <p className={`text-xs mt-2 text-red-600`}>
            New password must not be the same as the old password
          </p>
        ) : (
          <p className={`text-xs mt-2 ${passwordError && 'text-red-600'}`}>
            At least 8 characters long and contain at least one lowercase
            letter, and one number
          </p>
        )}
      </div>
      <div className=''>
        <TextInput
          label='Confirm New Password'
          onChange={handleInputChange('confirmPassword')}
          value={confirmPassword}
          placeholder='Re-enter your password'
          type='password'
        />
        {confirmPasswordError && (
          <p className='text-red-600 text-xs mt-2'>Password must be the same</p>
        )}
      </div>
      <div className='flex justify-between items-center'>
        <button
          className='border rounded-xl px-3 py-2'
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          className='border rounded-xl px-3 py-2'
          onClick={handleSubmit}
        >
          Update
        </button>
      </div>
    </dialog>
  );
};

export default ChangePasswordDialog;
